import React, { Component } from 'react';
import { Footer } from '../Components/Footer';
import TitleCard from '../Components/TitleCard.js';
import { ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { DATASET_NAV, getDatasetMeta } from './DataPlataformScreens/datasets';

// Componente funcional para cada bloco de opção
function OptionBlock({ title, description }) {
    const [hover, setHover] = React.useState(false);

    return (
        <div
            className='plataform-block-option'
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
        >
            <div
                className='plataform-block-option-image-text'
                style={{ display: 'flex', width: '100%' }}
            >
                <img
                    src={hover ? "/images/data-plataform/check_circle.svg" : "/images/data-plataform/check_circle_blue.svg"}
                    width="30"
                    alt="Check"
                />
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexDirection: 'row', width: '100%' }}>
                    <span style={{ marginLeft: '10px', color: '#3C3C3C' }}>{title}</span>
                    {hover && (
                        <img
                            src="/images/data-plataform/export.svg"
                            alt="Exportar"
                            style={{
                                marginLeft: '16px'
                            }}
                        />
                    )}
                </div>

            </div>
            <span
                className='plataform-block-option-text'
                dangerouslySetInnerHTML={{ __html: description }}
            />
        </div>
    );
}

class DataPlataform extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: new Date(),
            selected: 'municipio',
        };
    }

    handleSelect = (tipo) => {
        this.setState({ selected: tipo });
    };

    render() {
        const { selected } = this.state;

        return (
            <div className="container">
                <div className='home-first-block home-blocks' style={{
                    backgroundImage: `
                        linear-gradient(to bottom, rgba(255,255,255,0.6) 0%, rgba(255,255,255,0) 15%),
                        linear-gradient(to bottom, rgba(255,255,255,0) 80%, #fff 110%),
                        url('/images/home/background.svg')
                    `,
                    justifyContent: 'center',
                }}>
                    <div className='home-first-block-center'>
                        <div style={{ marginBottom: '30px' }}>
                            <img
                                src="/images/icons/home.svg"
                                width="18"
                                alt="Home"
                            />
                            <Link to="/" style={{ color: '#818181', fontSize: '14px', marginLeft: '10px', textDecoration: 'none' }}>
                                Início
                            </Link>
                            <ChevronRight style={{ width: '18px', color: '#818181', marginLeft: '5px' }} />
                            <span style={{ color: '#4654A3', fontSize: '14px', marginLeft: '5px' }}>Sobre a FiscalData</span>
                        </div>
                        <span className='title-text' style={{ marginTop: '25px', fontSize: '64px' }}>
                            Plataforma de Dados
                        </span>
                        <span style={{ marginBottom: '30px', color: 'gray', textAlign: 'center' }}>
                            Acesse e explore um universo de dados fiscais e socioeconômicos organizados para promover transparência, controle e tomada de decisão <br /> baseada em evidências.
                        </span>
                    </div>
                </div>
                {/* <div className='search-block'>
                    <div className='search-inner-block'>
                        <input
                            type="text"
                            placeholder="Pesquisar dados"
                            style={{
                                width: '100%',
                                height: '44px',
                                borderRadius: '8px',
                                border: '1px solid #818181',
                                background: '#fff',
                                padding: '0 44px 0 16px',
                                fontSize: '16px',
                                outline: 'none'
                            }}
                        />
                        <span
                            style={{
                                position: 'absolute',
                                right: '12px',
                                top: '45%',
                                transform: 'translateY(-50%)',
                                color: '#4654A3',
                                fontSize: '26px',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center'
                            }}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <circle cx="11" cy="11" r="8" stroke="currentColor" strokeWidth="2" />
                                <line x1="21" y1="21" x2="16.65" y2="16.65" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                            </svg>
                        </span>
                    </div>
                </div> */}
                <div className='plataform-block'>
                    <TitleCard
                        iconLeft={<img
                            src="/images/icons/escolha_certa.svg"
                            width="18"
                            alt="A FiscalData"
                        />}
                        label='DADOS'
                    />
                    <span className='title-text' style={{ textAlign: 'center' }}>
                        Transparência e inteligência para uma <br /> gestão pública eficiente
                    </span>
                    <div className='plataform-block-content'>
                        <div>
                            <div>
                                <img
                                    src={selected === 'municipio' ? "/images/data-plataform/big_munic.svg" : "/images/data-plataform/big_munic_branco.svg"}
                                    width={selected === 'municipio' ? "120" : "80"}
                                    alt="Municípios"
                                    style={{ cursor: 'pointer', transition: 'width 0.2s' }}
                                    onClick={() => this.handleSelect('municipio')}
                                />
                                <img
                                    src={selected === 'estado' ? "/images/data-plataform/big_state.svg" : "/images/data-plataform/big_state_branco.svg"}
                                    width={selected === 'estado' ? "120" : "80"}
                                    alt="Estados"
                                    style={{ cursor: 'pointer', transition: 'width 0.2s', marginLeft: '10px' }}
                                    onClick={() => this.handleSelect('estado')}
                                />
                                <img
                                    src={selected === 'uniao' ? "/images/data-plataform/big_uniao.svg" : "/images/data-plataform/big_uniao_branco.svg"}
                                    width={selected === 'uniao' ? "120" : "80"}
                                    alt="União"
                                    style={{ cursor: 'pointer', transition: 'width 0.2s', marginLeft: '10px' }}
                                    onClick={() => this.handleSelect('uniao')}
                                />
                            </div>
                        </div>
                        <div style={{ marginLeft: '50px' }}>
                            <img
                                src="/images/data-plataform/munic.svg"
                                width="600"
                                alt="Municípios"
                                style={{ display: selected === 'municipio' ? 'inline' : 'none' }}
                            />
                            <img
                                src="/images/data-plataform/state.svg"
                                width="600"
                                alt="Estados"
                                style={{ display: selected === 'estado' ? 'inline' : 'none' }}
                            />
                            <img
                                src="/images/data-plataform/uniao.svg"
                                width="600"
                                alt="União"
                                style={{ display: selected === 'uniao' ? 'inline' : 'none' }}
                            />
                        </div>
                        {DATASET_NAV.filter(grupo => grupo.selector === selected).map(grupo => (
                            <div key={grupo.group} style={{ alignItems: 'flex-start' }}>
                                <span className='title-text' style={{ fontSize: '32px' }}>{grupo.group}</span>
                                {grupo.items.map(item => (
                                    <Link key={item.key} to={item.path} style={{ textDecoration: 'none' }}>
                                        <OptionBlock
                                            title={item.label}
                                            description={getDatasetMeta(item.key)?.resumo || ''}
                                        />
                                    </Link>
                                ))}
                            </div>
                        ))}
                    </div>
                </div>
                <Footer />
            </div>
        );
    }
}

export default DataPlataform;